var $c21fdbae6e21b3c2$exports = {};
$c21fdbae6e21b3c2$exports = {
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`
};


export {$c21fdbae6e21b3c2$exports as default};
//# sourceMappingURL=it-IT.mjs.map
